// extracted by mini-css-extract-plugin
export var addToCartButton = "_pq-b";
export var arrowButtonContainer = "_pq-9";
export var arrowButtonIcon = "_pq-a";
export var carouselArrowButton = "_pq-6";
export var carouselElementContainer = "_pq-1";
export var galleryThumbnail = "_pq-d";
export var galleryThumbnailImage = "_pq-e";
export var left = "_pq-7";
export var productDisplayCarouselContainer = "_pq-0";
export var productTileContainer = "_pq-2";
export var productTileImage = "_pq-4";
export var productTileImageContainer = "_pq-3";
export var productTileTitle = "_pq-5";
export var right = "_pq-8";
export var sliderOverflow = "_pq-c";